// extracted by mini-css-extract-plugin
module.exports = {"MenuWrapper":"style-module--MenuWrapper--8NvsX"};